import { Box, Alert, Typography } from "@mui/material";
import { Contact } from "../../../types/Contact";
import React, { useEffect, useState } from "react";
import { fetchMotivationLetter } from "../../../services/connector";

function MotivationLetterTab({
    contact,
}: {
    contact: Contact;
}) {
    const [motivationLetter, setMotivationLetter] = useState<string | undefined>(undefined);

    useEffect(() => {
        const loadMotivationLetter = async () => {
            if (contact) {
                const fetchedMotivationLetter = await fetchMotivationLetter(contact);

                setMotivationLetter(fetchedMotivationLetter);
            } else {
                setMotivationLetter(undefined);
            }
        };

        loadMotivationLetter();

        return () => {
            setMotivationLetter(undefined);
        }
    }, [contact]);

    return (
        <Box sx={{ p: 2 }}>
            {contact.motivationLetter ?
                <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>{motivationLetter}</Typography> :
                <Alert severity="info">Le candidat n'a pas encore soumis de Lettre de motivation.</Alert>
            }
        </Box>
    );
}

export default React.memo(MotivationLetterTab, (prevProps, nextProps) => {
    return prevProps.contact.id === nextProps.contact.id;
});